import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelValidationService {

  validateFile(file: File, sheetName: string, requiredColumns: string[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Check if the sheet exists
        if (!workbook.SheetNames.includes(sheetName)) {
          resolve(false);
          return;
        }

        // Get the sheet
        const worksheet = workbook.Sheets[sheetName];

        // Find header row index by the required column
        const headerRowIndex = this.findHeaderRowIndex(worksheet, requiredColumns[0]);
        if (headerRowIndex === -1) {
          resolve(false); // column not found
          return;
        }

        const headers = this.getHeaders(worksheet, headerRowIndex);

        // Check if all required columns are present
        const missingColumns = requiredColumns.filter(col => !headers.includes(col));
        resolve(missingColumns.length === 0);
      };

      reader.onerror = (error) => reject(error);

      reader.readAsArrayBuffer(file);
    });
  }

  findHeaderRowIndex(worksheet: any, columnName: string): number {
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let row = range.s.r; row <= range.e.r; row++) { 
      const rowValues = [];
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        const cell = worksheet[cellAddress];
        rowValues.push(cell ? cell.v : undefined);
      }
      
      if (rowValues.includes(columnName)) {
        return row;
      }
    }
    return -1;
  }

  private getHeaders(worksheet: XLSX.WorkSheet, headerRowIndex: number): string[] {
    const headers: string[] = [];
    const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cell = worksheet[XLSX.utils.encode_cell({ r: headerRowIndex, c: col })];
      if (cell && cell.v) {
        headers.push(cell.v.toString());
      }
    }
    return headers;
  }
}
